import styled from 'styled-components'
import Button from '@mui/material/Button';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { logoutUser } from '../../services/login.js'
import { useDispatch } from 'react-redux'
import { user,userLogin } from '../../redux/actions/loginActions.js'
import fondo from '../../imgs/fondomenu.avif'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { modifcarShoppingCart } from '../../redux/actions/shoppingCartActions.js'
import { Link } from "react-router-dom";

const Container=styled.div`
	height:200px;
	width:400px;
	background-color:white;
	z-index:5;
	border-radius:5px;
	display:flex;

`;
const Overlay2=styled.div`
	position:absolute;
	background-image:url(${fondo});
	background-size:70%;
	background-position:center;
	height:100%;
	width:100%;	
	opacity:0.07
	
`;
const ContainerData=styled.div`
	width:350px;
	display:flex;
	flex-direction:column;
	justify-content:space-around;
	align-items:center;
	position:relative

`;
const ContainerButonCntraccion=styled.div`
	position:absolute;
	top:1px;
	right:1px

`;
const Name=styled.div`
	font-weight: bold;
	width:200px;
	display:flex;
	text-align:left;
	fo
`;
const Usuario=styled.div`
	font-weight:normal;
	font-size:10px;
	text-align:left;
`;

const PerfilLink=styled.div`
	display:flex;
	z-index:1;
	cursor:pointer;
	align-items:center;
	width:100%;
	justify-content:space-around

`;

export default function InfoUserLogin(props){
	let { close,userActive } = props;
	let dispatch=useDispatch();

	let deleteData=()=>{
				dispatch(userLogin(false));
 				dispatch(user("")); 
 				dispatch(modifcarShoppingCart([]))				
	};



	let logout=async()=>{
		try{
 			await logoutUser();
 			deleteData();

         }catch(err){console.log(err);deleteData()}
	}

	let closeDetail=()=>{
		close(false)
	}

	return(

		<Container>
			<ContainerData>
				<Overlay2/>
				<div>
					<Name>{userActive.name} </Name>
					
					<Usuario>{userActive.correo}</Usuario>
					<div></div>
				</div>
				<Link to="dashboard/juegos" style={{zIndex:"5",textDecoration:"none",color:"black"}}>
					<PerfilLink>Ir a  dashboard  → </PerfilLink>
				</Link>
				<ContainerButonCntraccion>
					<Button onClick={closeDetail} sx={{color:"black"}} endIcon={< KeyboardArrowUpIcon sx={{color:"black"}}/>} >cerrar</Button>
				</ContainerButonCntraccion>
				
			</ContainerData>
			
			<Button onClick={logout} variant="contained" size="large"  sx={{ backgroundColor: '#111111','&:hover':{backgroundColor: 'black'},}} endIcon={< LogoutOutlinedIcon/>} >logout</Button>
		</Container>

		)

}